import Vue from 'vue';
import VueCookies from 'vue-cookies';
import VueHighlightJS from "vue-highlight.js";

import json from "highlight.js/lib/languages/json";
import bash from "highlight.js/lib/languages/bash";

import "highlight.js/styles/atom-one-light.css";

import {
    AlertPlugin,
    CollapsePlugin,
    DropdownPlugin,
    ListGroupPlugin,
    ModalPlugin,
    NavbarPlugin,
    NavPlugin,
    VBScrollspyPlugin,
    FormSelectPlugin
} from 'bootstrap-vue';

import {library} from '@fortawesome/fontawesome-svg-core';
import {
    faAd,
    faCopy,
    faAnalytics,
    faAngleDoubleLeft,
    faAngleDoubleRight,
    faAngleLeft,
    faAngleRight,
    faArrowCircleLeft,
    faArrowDown,
    faArrowRight,
    faArrowUp,
    faBalanceScaleRight,
    faBrowser,
    faChartBar,
    faChartNetwork,
    faCheck,
    faCheckCircle,
    faCircle,
    faClock,
    faCoin,
    faComment,
    faDownload,
    faCommentEdit,
    faCookieBite,
    faCreditCard,
    faCreditCardFront,
    faEdit,
    faEllipsisH,
    faEllipsisHAlt,
    faEnvelope,
    faExclamation,
    faExclamationCircle,
    faEye,
    faEyeSlash,
    faFileAlt,
    faFileContract,
    faFont,
    faIdCardAlt,
    faInfo,
    faInfoCircle,
    faLayerPlus,
    faListUl,
    faMapMarked,
    faNetworkWired,
    faPen,
    faPencil,
    faPencilAlt,
    faPollH,
    faProjectDiagram,
    faQuestionCircle,
    faRepeat,
    faReply,
    faSearch,
    faServer,
    faShieldCheck,
    faShippingFast,
    faShoppingCart,
    faSmile,
    faStopwatch,
    faStream,
    faSync,
    faTags,
    faTimes,
    faTimesCircle,
    faTrash,
    faUndo,
    faUser,
    faUsers,
    faUserShield,
    faUserTie,
    faVideo,
    faVoteNay,
    faWifi,
    faCommentAltCheck,
    faGift,
    faFunnelDollar,
    faFilePdf,
    faFileCsv
} from '@fortawesome/pro-light-svg-icons';
import {FontAwesomeIcon} from '@fortawesome/vue-fontawesome';

import Echo from "laravel-echo"
import * as Sentry from '@sentry/browser';
import * as Integrations from '@sentry/integrations';
import {Integrations as TracingIntegrations} from '@sentry/tracing';

/**
 * Vue configuration
 */
    // Sentry makes trouble with scrollspy. That's why we disable it on certain pages.
let disable = [
        'https://www.einfach-abmahnsicher.de/hilfe/datenschutz',
        'https://www.einfach-abmahnsicher.de/hilfe/impressum',
        'https://www.einfach-abmahnsicher.de/hilfe/onlineshop',
        'https://www.einfach-abmahnsicher.de/datenschutz',
    ];

if (!disable.includes(window.location.href)) {
    Sentry.init({
        dsn: process.env.MIX_SENTRY_LARAVEL_DSN,
        integrations: [
            new Integrations.Vue({Vue, attachProps: true}),
            new TracingIntegrations.BrowserTracing(),
        ],
        environment: process.env.MIX_APP_ENV,
        tracesSampleRate: 0.3
    });
}

Vue.config.productionTip = false;

Vue.component('FontAwesomeIcon', FontAwesomeIcon);

Vue.use(ModalPlugin);
Vue.use(DropdownPlugin);
Vue.use(AlertPlugin);
Vue.use(CollapsePlugin);
Vue.use(ListGroupPlugin);
Vue.use(NavPlugin);
Vue.use(NavbarPlugin);
Vue.use(VBScrollspyPlugin);
Vue.use(FormSelectPlugin);
Vue.use(VueCookies);

library.add(
    faCheckCircle,
    faCheck,
    faExclamationCircle,
    faInfoCircle,
    faQuestionCircle,
    faEdit,
    faTrash,
    faRepeat,
    faBalanceScaleRight,
    faUserShield,
    faShoppingCart,
    faFileContract,
    faVoteNay,
    faUsers,
    faSearch,
    faArrowDown,
    faArrowRight,
    faArrowUp,
    faAngleDoubleRight,
    faAngleDoubleLeft,
    faPollH,
    faNetworkWired,
    faUser,
    faPencil,
    faShippingFast,
    faCreditCardFront,
    faTags,
    faWifi,
    faUndo,
    faInfo,
    faShieldCheck,
    faEyeSlash,
    faProjectDiagram,
    faSmile,
    faListUl,
    faAnalytics,
    faTimesCircle,
    faPen,
    faDownload,
    faArrowCircleLeft,
    faComment,
    faStopwatch,
    faSync,
    faClock,
    faPencilAlt,
    faTrash,
    faReply,
    faCommentEdit,
    faCheck,
    faChartNetwork,
    faBrowser,
    faCoin,
    faFileAlt,
    faLayerPlus,
    faTimes,
    faTimesCircle,
    faExclamation,
    faEye,
    faChartBar,
    faAd,
    faServer,
    faVideo,
    faCreditCard,
    faEnvelope,
    faMapMarked,
    faFont,
    faEllipsisHAlt,
    faIdCardAlt,
    faEllipsisH,
    faAngleRight,
    faAngleLeft,
    faStream,
    faCookieBite,
    faCircle,
    faUserTie,
    faCommentAltCheck,
    faCopy,
    faGift,
    faFunnelDollar,
    faFilePdf,
    faFileCsv
);

/**
 * We'll load the axios HTTP library which allows us to easily issue requests
 * to our Laravel back-end. This library automatically handles sending the
 * CSRF token as a header based on the value of the "XSRF" token cookie.
 */

window.axios = require('axios');

window.axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';

/**
 * Next we will register the CSRF Token as a common header with Axios so that
 * all outgoing HTTP requests automatically have it attached. This is just
 * a simple convenience so we don't have to attach every token manually.
 */

let token = document.head.querySelector('meta[name="csrf-token"]');

if (token) {
    window.axios.defaults.headers.common['X-CSRF-TOKEN'] = token.content;
}

/**
 * Echo exposes an expressive API for subscribing to channels and listening
 * for events that are broadcast by Laravel. Echo and event broadcasting
 * allows your team to easily build robust real-time web applications.
 */

window.Pusher = require('pusher-js');

window.Echo = new Echo({
    broadcaster: 'pusher',
    key: process.env.MIX_PUSHER_APP_KEY,
    wsHost: 'socket.einfach-abmahnsicher.de',
    wsPort: 443,
    disableStats: true,
    encrypted: true,
    enabledTransports: ['ws', 'wss']
});

Vue.use(VueHighlightJS, {
    languages: {
        bash,
        json
    }
});
